/* eslint-disable react/require-default-props */
/* eslint-disable react/forbid-prop-types */

import React, { memo } from 'react';
import { Button } from 'reactstrap';
import PropType from 'prop-types';
import SpinnerCircles from '../../../../../../Spinner/SpinerCircles';
import '../../AdminTools.css';
import InfoPopup from '../../../../../../InfoPopup';
import { TOOLTIPS_TEXT } from '../../../../../../../lib/constants';

const ModemRow = memo(({ simStateLoading, fetchSimStatus, onClick }) => {
  return (
    <div className="modam-row mt-2 mb-2 mr-1">
      <h1 className="heading d-flex">
        Sim Activation Check
        <sup>
          <InfoPopup id="sim-activate" text={TOOLTIPS_TEXT.SIM_ACT_CHECK} />
        </sup>
      </h1>
      <Button
        disabled={simStateLoading}
        onClick={onClick}
        color="primary"
        className="admin-tool-execute-btn"
      >
        {simStateLoading ? <SpinnerCircles /> : 'Execute'}
      </Button>
      <br />
    </div>
  );
});

ModemRow.propTypes = {
  simStateLoading: PropType.bool,
  fetchSimStatus: PropType.func,
};

export default ModemRow;
